/**
 * Get the vehicle sizes from the current location.
 */

import { isEqual } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';
import type { VehicleType } from '/index';
import type { RootState } from '/business/shared/state/store';
import type { Step1SelectorProps } from '/business/shared/state/selectors/types';
import getVehicleFuelOptionsSelector from './getVehicleFuelOptionsSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);
type VehicleFuelOption = VehicleType['items'][number]['children']['items'][number];
export type VehicleSizeOption = VehicleFuelOption['children']['items'][number];
export type VehicleSizesFactory = (fuelType: string | null) => VehicleSizeOption[];

const getVehicleSizesSelectorBase = createDeepEqualSelector(getVehicleFuelOptionsSelector, (vehicleFuelOptions) => {
  if (!vehicleFuelOptions) {
    return null;
  }
  return (fuelType: string | null): VehicleSizeOption[] => {
    return vehicleFuelOptions
      ?.filter(({ title }) => {
        return title && fuelType && title.toLowerCase() === fuelType.toLowerCase();
      })
      ?.reduce<VehicleSizeOption[]>((memo, { children }) => {
        return [...children.items, ...memo];
      }, [])
      ?.reverse();
  };
});

export default function getVehicleSizesSelector(
  state: RootState,
  ownProps: Step1SelectorProps | null = null,
): VehicleSizesFactory | null {
  return getVehicleSizesSelectorBase(state, ownProps ?? undefined);
}
